import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Col, Row } from 'react-bootstrap'
import { Breadcrumb } from 'react-breadcrumbs'
import { Field, reduxForm } from 'redux-form'

import { Input } from 'Components/Form/Input'
import { authorization } from 'Module/Auth/Auth'
import { Breadcrumbs } from 'Components/Breadcrumbs'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { SectionLabel } from 'Components/Section/SectionLabel'
import { SectionTitle } from 'Components/Section/SectionTitle'
import { SectionWrapper } from 'Components/Section/SectionWrapper'
import { SubmitButtonBlock } from 'Components/Form/SubmitButton/SubmitButtonBlock'
import { UserDetailsWrapper } from 'Components/UserManagement/UserDetailsWrapper'
import { getUserById } from 'Reducers/Users/actions'
import SubmitButton from 'Components/Form/SubmitButton'
import UserManagementIcon from 'Assets/Images/icons/userManagement'
import { PATHS } from 'Config/Routing/paths'
import { Dropzone } from 'Components/Form/Dropzone'

import { required } from 'Utils/Validators/formValidation'

class ProfileEditFormUnstyled extends PureComponent {
  componentWillMount() {
    const { getUserById } = this.props
    const { id } = authorization.getUser()
    getUserById(id)
  }

  renderBreadcrumbs() {
    return (
      <div>
        <Breadcrumbs icon={<UserManagementIcon style={{ width: 24 }} />} />
        <Breadcrumb
          data={{
            title: 'Profile',
            pathname: `${PATHS.main.dashboard}${PATHS.dashboard.profile}`,
          }}
        />
        <Breadcrumb
          data={{
            title: 'Edit',
            pathname: `${PATHS.main.dashboard}${PATHS.dashboard.settings}${
              PATHS.dashboard.userManagement
            }`,
          }}
        />
      </div>
    )
  }

  render() {
    const { className, handleSubmit, userById, profilePicture } = this.props

    if (!userById.id) return null

    return (
      <LayoutDashboard>
        {this.renderBreadcrumbs()}
        <UserDetailsWrapper>
          <form className={className}>
            <SectionWrapper className="section-wrapper first">
              <SectionTitle className="section-title">
                Edit Profile
              </SectionTitle>
              <Col xs={12}>
                <Col xs={10}>
                  <Row>
                    <Col xs={3}>
                      <SectionLabel className="section-label">
                        First Name
                      </SectionLabel>
                      <Field
                        component={Input}
                        id="firstName"
                        name="firstName"
                        validate={[required]}
                      />
                    </Col>
                    <Col xs={3}>
                      <SectionLabel className="section-label">
                        Last Name
                      </SectionLabel>
                      <Field
                        component={Input}
                        id="lastName"
                        name="lastName"
                        validate={[required]}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={3}>
                      <SectionLabel className="section-label">
                        Email Address
                      </SectionLabel>
                      {userById.email}
                    </Col>
                    <Col xs={3}>
                      <SectionLabel className="section-label">
                        Role
                      </SectionLabel>
                      {userById.role}
                    </Col>
                  </Row>
                </Col>
                <Col xs={2}>
                  <Field
                    component={Dropzone}
                    name={'profilePicture'}
                    src={profilePicture}
                    props={{
                      mainLabel: 'Profile Picture',
                    }}
                  />
                </Col>
              </Col>
            </SectionWrapper>
            <SubmitButtonBlock>
              <SubmitButton value="Save" onClick={handleSubmit} />
            </SubmitButtonBlock>
          </form>
        </UserDetailsWrapper>
      </LayoutDashboard>
    )
  }
}
ProfileEditFormUnstyled.propTypes = {
  userById: PropTypes.object.isRequired,
  getUserById: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  userById: state.users.userById,
  initialValues: {
    firstName: state.users.userById.firstName,
    lastName: state.users.userById.lastName,
    profilePicture: `${state.users.userById.profilePicture}?${
      state.users.userById.updatedAt
    }`,
  },
  profilePicture: state.users.userById.profilePicture,
})

ProfileEditFormUnstyled = reduxForm({
  enableReinitialize: true,
  form: 'clientEditForm',
})(ProfileEditFormUnstyled)

ProfileEditFormUnstyled = connect(
  mapStateToProps,
  { getUserById },
)(ProfileEditFormUnstyled)

export default ProfileEditFormUnstyled



// WEBPACK FOOTER //
// ./src/Containers/Form/Profile/ProfileEdit/unstyled.js